import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import _ from 'lodash';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { PanelModule } from 'primeng/panel';
import { ModalComponent } from '../../shared/modal/modal.component';
import { CustomFormControl } from '../../shared/shared.model';
import { MultiSelectModule } from 'primeng/multiselect';
import { InputMaskModule } from 'primeng/inputmask';
import { FileUploadModule } from 'primeng/fileupload';
import { DoumentUploadService } from '../../services/doucument-upload-service/doument-upload.service';
import { LoaderService } from '../../services/loader-service/loader.service';
import { TableModule } from 'primeng/table';
import { CheckboxModule } from 'primeng/checkbox';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CreateUuidService } from '../../services/create-uuid/create-uuid.service';
import { AccountNames } from '../../order-info/order-info.model';
import { MessageService } from 'primeng/api';
import { VocabHelperService } from '../../services/vocab-helper/vocab-helper.service';
import { Defendant } from './subpoena.model';
import { CaseInformationComponent } from '../../shared/components/case-information/case-information.component';

@Component({
  selector: 'app-subpoena',
  imports: [InputTextModule,CommonModule,FormsModule, FileUploadModule, CheckboxModule,TableModule, ButtonModule, SelectModule, ReactiveFormsModule,DropdownModule, PanelModule, ModalComponent, MultiSelectModule,RadioButtonModule, InputMaskModule, CaseInformationComponent],
  templateUrl: './subpoena.component.html',
  styleUrl: './subpoena.component.scss'
})
export class SubpoenaComponent {
  @Input() subjects: any;
  @Input() formData: any;
  @Input() orderInfoAccountName: any;
  @Input() states: any;
  @Input() editOrder: any;
  @Output() formChanged = new EventEmitter<void>();
  showInitialPleadingPanel: string = 'no';
  formGroup!: FormGroup;
  plaintiffSubjectNames: any [] = [];
  defendantSubjectNames: any [] = [];
  defendants: Defendant [] = [];
  selectedPartyIndex: number = 0;
  selectedPartyType: 'plaintiff' | 'defendant' = 'plaintiff';
  showValidationErrors: boolean = false;
  accountPlaintiffRepresenting: any[] = [];
  showDeleteModal: boolean = false;
  itemToDelete: any;
  deleteType: any;
  fileUploadVisible: boolean = false;
  fileSizeError: boolean = false;
  maxFileSize: number = 104857600;
  isUploadDisabled: boolean = true;
  fileUpload: any;
  recordFile: any;
  attachments: any[] = [];
  showFileDeleteModal: boolean = false;
  itemFileToDelete: number | null = null;
  showAddPartyModal = false;
  partyNames: string[] = [''];
  partyName = '';
  categories : any = [];
  hidePanel: Boolean = false;
  modalContext: 'plaintiff' | 'defendant' | null = null;
  accountNames: AccountNames[] = [];
  fileName: string = '';

  initialPleadingOptions = [
    { label: 'Yes', value: 'yes' },
    { label: 'No', value: 'no' }
  ];

  chooseCounsellOptions = [
    { label: 'Defendent Counsell', value: true },
    { label: 'Plantiff Counsell', value: false }
  ];

  constructor( 
      private readonly documentUploadSercive: DoumentUploadService, 
      private readonly vocabHelperService: VocabHelperService, 
      private messageService: MessageService,
      
      private readonly loaderService: LoaderService,
      private readonly uuidService: CreateUuidService,
    ) {
    }

  ngOnInit(): void {
    this.fileUploadVisible = true;

    this.vocabHelperService.getVocabData(['UserOrganization']).subscribe({
          next: (data) => {
            if (data) {
              
               const accountNamesData = data.find(d => d.vocabularyName === 'UserOrganization');
          if (accountNamesData) {
            this.accountNames = accountNamesData.vocabularyItems.map(item => ({ name: item.description, value: item.code }));
          }
              
            }
          },
          error: (error) => {
            this.messageService.add({ severity: 'error', summary: 'ERROR', detail: 'System error, please contact help desk at EXLRecords.Helpdesk@exlservice.com', sticky: true });
          },
          complete: () => {
            if (this.formData) {
              this.initializeFormData();
            }
          }
        }
        );

    this.formGroup = new FormGroup({
      'initialPleading': new CustomFormControl('yes', 'Initial Pleadings'),
      'orderInfoAttachmentLabel': new FormControl('Attachments Label', [Validators.required]),  
      'orderInfoAttachmentFile': new FormControl(null),
      'chooseCounsell': new CustomFormControl(true, 'Choose Counsell', [Validators.required]),
      'plaintiffCounseals': new FormArray([this.createplaintiffCounsealFormGroup()]),
      'defendantCounseals': new FormArray([this.createdefendantCounsealFormGroup()]),
      'judge': new FormControl(null),
      'courtKeys': new FormControl(null),
      'court': new CustomFormControl(null, 'Court', [Validators.required]),
      'courtStreetAddress': new FormControl(null),
      'jurisdictionCounty': new CustomFormControl(null, 'Jurisdiction County', [Validators.required]),
      'state': new FormControl(null),
      'cityName': new FormControl(null),
      'zipCode': new FormControl(null),
      'caseNumber': new CustomFormControl(null, 'Case number', [Validators.required]),
      'selectedLevel': new FormControl(null),
      'rsnInitialPleadings': new FormControl(null),
      'caseName': new CustomFormControl(null, 'Case Name', [Validators.required])
    }); 

    if(this.formData) {
      this.initializeFormData();
    }
    
    this.formGroup.valueChanges.subscribe(()=>{
      this.formChanged.emit();
    });
    this.toggleCounsellControls(this.formGroup.get('chooseCounsell')?.value);

    if(this.subjects) {
      _.forEach(this.subjects?.subjects, (subject: any) => {
        if(!this.plaintiffSubjectNames.find(s => s.name === subject.recordSubjectName)) {
        const plaintiffNewOptions = { name: subject.recordSubjectName, value: subject.recordSubjectName};
        this.plaintiffSubjectNames.push(plaintiffNewOptions);
      }
      });
    }

    const plaintiffArray = this.formGroup.get('plaintiffCounseals') as FormArray;
    if (plaintiffArray && plaintiffArray.length > 0) {
      const firstGroup = plaintiffArray.at(0);

      const newSubjects = (this.subjects?.subjects ?? []).map((subject: any) => ({
        name: subject.recordSubjectName,
        value: subject.recordSubjectName
      }));

      const currentSelections = firstGroup.get('plaintiffs')?.value ?? [];
      const merged = [
        ...currentSelections,
        ...newSubjects.filter(
          (s: any) => !currentSelections.some((c: any) => c.value === s.value)
        )
      ];
      firstGroup.get('plaintiffs')?.patchValue(merged);
    }

  }

  get initialPleading() {
    return this.formGroup.get('initialPleading');
  }

  get isInitialPleadingsChecked(): boolean {
    return this.formGroup.get('selectedLevel')?.value === true;
  }

 get selectedLevel() {
    return this.formGroup.get('selectedLevel');
  }

  onFileSelect(event: any, fileUpload: any) {
    this.fileName = event.files[0]?.name || '';
    if (event.files[0] && event.files[0].size > this.maxFileSize) {
      this.fileSizeError = true;
      this.isUploadButtonDisabled();
      return;
    } else 
      this.fileSizeError = false;
    
    this.fileUpload = fileUpload;
    this.recordFile = event.files[0];
    this.formGroup.get('orderInfoAttachmentLabel')?.setValidators(Validators.required);   
    this.formGroup.get('orderInfoAttachmentLabel')?.updateValueAndValidity();
    this.isUploadButtonDisabled();
    this.isFileUploaded();
  }

  isFileUploaded(): boolean {
      const control = this.formGroup.get('orderInfoAttachmentLabel');
      const isRequired = control?.hasValidator(Validators.required) ?? false;
      return isRequired;
    }

  uploadFile(event: any) {
      this.loaderService.show(); // Set isLoading to true before starting the upload
      this.documentUploadSercive.uploadDocument(this.recordFile, this.fileName).subscribe(response => {
        this.loaderService.hide();
        if (response) {
          if (this.recordFile && this.formGroup.get('orderInfoAttachmentLabel')?.valid) {
            let labelText = '';
            if (this.formGroup.get('orderInfoAttachmentLabel')?.value.value === 'OTH') {
              labelText = this.formGroup.get('orderInfoAttachmentLabel')?.value.name + ' - ' + this.formGroup.get('orderInfoAttachmentExplanation')?.value;
            }
            else {
              labelText = this.formGroup.get('orderInfoAttachmentLabel')?.value.value;
            }
            const newAttachment = {
              label: this.formGroup.get('orderInfoAttachmentLabel')?.value?.value,
              filename: this.recordFile?.name,
              fileId: Date.now(), // Unique ID for the file
              description: labelText,
              storageId: response?.id,
              storageProviderId: response?.providerId,
              type: this.recordFile?.type,
              size: this.recordFile?.size,
              sizeText: _.toString((this.recordFile?.size > 0 ? _.round(this.recordFile?.size/1024, 2) : 0)) + ' KB'
            };
            this.attachments.push(newAttachment);
            this.formGroup.get('orderInfoAttachmentFile')?.setValue(this.attachments);
  
            // this.formGroup.
            // this.selectedFile = null;
            // this.form.reset();
            this.cancelUpload(this.fileUpload);
            // this.counter++;
          }
        }
      }, error => {
        this.loaderService.hide();
        console.error('File upload failed:', error);
      });
    }
    
  cancelUpload(fileupload: any) {
    fileupload.clear();
    fileupload.msgs = [];
    this.fileSizeError = false;
    this.fileUpload = null;
    this.isFileUploaded();
    this.isUploadButtonDisabled();
  }

   showFileDeletionModal(fileId: number): void {
    this.showFileDeleteModal = true;
    this.itemFileToDelete = fileId;
  }
  
   downloadFile(fileId: string) {
    /**
     * Placeholder for file download logic.
     */
  }

onModalContinue() {
  // Handle continue logic here
  this.showAddPartyModal = false;
}

trackByIndex(index: number, item: any): number {
  return index;
}

onAddMoreClicked() {
  this.partyNames = ['']; // Reset to one field every time
  this.showAddPartyModal = true;
}

addMoreInput(event: Event) {
  event.preventDefault(); // prevent page refresh
  this.partyNames.push('');
}

openAddPartyModal(context: 'plaintiff' | 'defendant', index: number) {
  this.selectedPartyType = context;
  this.selectedPartyIndex = index;
  this.modalContext = context;
  this.partyNames = [''];
  this.showAddPartyModal = true;
  this.showValidationErrors = false;
}

saveParty() {
  this.showValidationErrors = false;

  // Trim and validate names
  const validNames = this.partyNames.map(name => name?.trim()).filter(name => !!name);

  if (validNames.length === 0) {
    this.showValidationErrors = true;
    return;
  }

  if (this.selectedPartyType === 'plaintiff') {
    // Add to available options
    validNames.forEach(name => {
      this.plaintiffSubjectNames.push({ name }); // Assuming optionLabel is 'name'
    });

    // Auto-select newly added names in the specific FormControl
    const control = (this.formGroup.get('plaintiffCounseals') as FormArray).at(this.selectedPartyIndex);
    const currentSelection = control.get('plaintiffs')?.value || [];

    // Append new names to selection
    control.get('plaintiffs')?.setValue([...currentSelection, ...validNames.map(name => ({ name }))]);
  }

   if (this.selectedPartyType === 'defendant') {
    // Add new entries to global list (defendant)
    validNames.forEach(name => {
      if (!this.defendantSubjectNames.some(d => d.name === name)) {
        this.defendantSubjectNames.push({ name });
      }
    });

    const formArray = this.formGroup.get('defendantCounseals') as FormArray;
    const targetControl = formArray.at(this.selectedPartyIndex);
    const currentValue = targetControl.get('defendants')?.value || [];
    const newValues = [...currentValue, ...validNames.map(name => ({ name }))];
    targetControl.get('defendants')?.setValue(newValues);
  }

  this.showAddPartyModal = false;
}


onModalCancel() {
  this.showAddPartyModal = false;
  this.partyNames = [''];
  this.modalContext = null;
}

    
  isUploadButtonDisabled() {
    if (!this.fileSizeError && this.fileUpload && this.formGroup.get('orderInfoAttachmentLabel')?.value) {
      this.isUploadDisabled = false;
    } else {
      this.isUploadDisabled = true;
    }
  }
  /**
   * Gets the plaintiffCounseal form array.
   * @returns The FormArray of plaintiffCounseal.
   */
  get plaintiffCounseals(): FormArray {
    return this.formGroup.get('plaintiffCounseals') as FormArray;
  }

  /**
   * Adds a new plaintiffCounseal to the plaintiffCounseal form array.
   */
  addPlaintiffCounseal(): void {  
    const group = this.createplaintiffCounsealFormGroup();

    const recordSubjectNameControl = group.get('recordSubjectName');

    recordSubjectNameControl?.valueChanges.subscribe((selectedValue) => {
    const components = group.get('keys')?.value?.components;

    if (selectedValue && components && typeof components === 'object') {
      // Extract the key (e.g., 'external-id') from components
      const componentKey = Object.keys(components).find(key => key === 'external-id');

      if (componentKey) {
        selectedValue.keys = componentKey;  // Assign the key name: 'external-id'
      }
    }
  });

    this.plaintiffCounseals.push(group);
    this.togglePlaintiffControls(this.formGroup.get('chooseCounsell')?.value);
  }

  /**
   * Removes a plaintiffCounseal from the plaintiffCounseal form array.
   * @param index The index of the plaintiffCounseal to remove.
   */
  removePlaintiffCounseal(index: number) {
    // this.plaintiffCounseals.removeAt(index);
    this.showDeleteModal = true;
    this.itemToDelete = index;
    this.deleteType = 'plaintiffCounseal';
  }

  createplaintiffCounsealFormGroup(item?: any): FormGroup {

    const existingKeys = Array.isArray(item?.keys) ? [...item.keys] : [];
    let keys = this.uuidService.generatePartyExternalId(existingKeys);
    
    if (Array.isArray(item?.plaintiffs)) {
      let selectedPlaintiffs =  [];
      item.plaintiffs = item.plaintiffs.map((subject: any) => {

      if(!this.plaintiffSubjectNames.find(s => s.name === subject.name)) {
        const plaintiffNewOptions = { name: subject.name, value: subject.name, keys: subject.keys };
        selectedPlaintiffs.push(subject.name);
        this.plaintiffSubjectNames.push(plaintiffNewOptions);
      }

      subject = { name: subject.name, value: subject.name, keys: subject.keys };
      return subject;
    });
  }
    var fb =  new FormGroup({
      'plaintiffs': new CustomFormControl(item ? item?.plaintiffs : null, 'Plantiff Representing', [Validators.required]),
      'plantiffCounselAttorneyName': new CustomFormControl(item ? item?.plantiffCounselAttorneyName : null, 'Plantiff Counsel Full Name', [Validators.required]),
      'plantiffCounselBarNumer': new CustomFormControl(item ? item?.plantiffCounselBarNumer : null, 'Plantiff Bar Number'),
      'plantiffCounselFirmName': new CustomFormControl(item ? item?.plantiffCounselFirmName : null, 'Plantiff Law Firm', [Validators.required]),
      'streetAddress': new FormControl(item ? item?.streetAddress : null),
      'city': new FormControl(item ? item?.city : null),
      'state': new FormControl(item ? item?.state : null),
      'zip': new FormControl(item ? item?.zip : null),
      'phone': new FormControl(item ? item?.phone : null),
      'extn': new FormControl(item ? item?.extn : null),
      'fax': new FormControl(item ? item?.fax : null),
      'email': new FormControl(item ? item?.email : null, Validators.email),
      'isNew': new FormControl(item ? item.isNew : true),
      'keys': new FormControl(keys)
    });
     return fb;
  }

  toggleCounsellControls(show: boolean){
    this.togglePlaintiffControls(show);
    this.toggleDefendantControls(show);
  }

  togglePlaintiffControls(show: boolean) {
    this.plaintiffCounseals.controls.forEach((group: any, index: number) => {
      if (show || (!show && index > 0)) {
        group.get('plantiffCounselAttorneyName')?.setValidators(Validators.required);
        //group.get('plantiffCounselBarNumer')?.setValidators(Validators.required);
        group.get('plantiffCounselFirmName')?.setValidators(Validators.required);
        group.get('plaintiffs')?.setValidators(Validators.required);
 
      } else if (!show && index < 1) {    
          group.get('`plantiffCounselAttorneyName`')?.clearValidators();
          group.get('plantiffCounselBarNumer')?.clearValidators();
          group.get('plantiffCounselFirmName')?.setValidators(Validators.required);
          group.get('plaintiffs')?.setValidators(Validators.required);
        }
     
      // Always update validity after validators are set/cleared
      Object.keys(group.controls).forEach(key => {
        group.get(key)?.updateValueAndValidity();
      });
    });
  }

  toggleDefendantControls(show: boolean) {
    this.defendantCounseals.controls.forEach((group: any, index: number) => {
      if (show && index < 1) {
        group.get('defendantCounselAttorneyName')?.clearValidators();
        group.get('defendantCounselBarNumer')?.clearValidators();
        group.get('defendantCounselFirmName')?.setValidators(Validators.required);
        group.get('defendants')?.setValidators(Validators.required);

      } else if(!show || (show && index > 0)){
        group.get('defendantCounselAttorneyName')?.setValidators(Validators.required);
        //group.get('defendantCounselBarNumer')?.setValidators(Validators.required);
        group.get('defendantCounselFirmName')?.setValidators(Validators.required);
        group.get('defendants')?.setValidators(Validators.required);
      }

      Object.keys(group.controls).forEach(key => {
        group.get(key)?.updateValueAndValidity();
      });
    });
  }


  /**
   * Gets the defendant form array.
   * @returns The FormArray of defendant.
   */
  get defendantCounseals(): FormArray {
    return this.formGroup.get('defendantCounseals') as FormArray;
  }

  /**
   * Adds a new defendant to the defendant form array.
   */
  addDefendant(): void {  
    const group = this.createdefendantCounsealFormGroup();

    group.get('defendantCounselFirmName')?.setValue('');
    group.get('defendantCounselFirmName')?.enable();
    const nameControl = group.get('name');

    nameControl?.valueChanges.subscribe((selectedValue) => {
      const components = group.get('keys')?.value?.components;

      if (selectedValue && components && typeof components === 'object') {
        const componentKey = Object.keys(components).find(key => key === 'external-id');

        if (componentKey) {
          selectedValue.keys = componentKey;
        }
      }
    });

    this.defendantCounseals.push(group);
    this.toggleDefendantControls(true);
  }

  /**
   * Removes a defendant from the defendant form array.
   * @param index The index of the defendant to remove.
   */
  removeDefendant(index: number) {
    // this.defendants.removeAt(index);
    this.showDeleteModal = true;
    this.itemToDelete = index;
    this.deleteType = 'defendant';
  }

  createdefendantCounsealFormGroup(item?: any): FormGroup {

    const existingKeys = Array.isArray(item?.keys) ? [...item.keys] : [];
    let keys = this.uuidService.generatePartyExternalId(existingKeys);

    if (Array.isArray(item?.defendants)) {

      item.defendants = item.defendants.map((subject: any) => {

        if(!this.defendantSubjectNames.find(s => s.name === subject.name)) {
        const defNewOptions = { name: subject.name, value: subject.name, keys: subject.keys };
        this.defendantSubjectNames.push(defNewOptions);
      }

        subject = { name: subject.name, value: subject.name, keys: subject.keys };
        return subject;
      });
    }
    let value: any;
    if(item?.defendantCounselFirmName) {
      value = {value: item.defendantCounselFirmName, disabled: false};
    }
    if(item?.defendantCounselFirmName === undefined || item?.defendantCounselFirmName === this.orderInfoAccountName) {
      value = {value: this.orderInfoAccountName, disabled: true};
    }
    return new FormGroup({
      'defendantCounselBarNumer': new CustomFormControl(item ? item?.defCounselBarNum : null, 'Defendant Bar Number'),
      'defendantCounselFirmName': new CustomFormControl(value , 'Defendant Law Firm', [Validators.required]),
      'defendants': new CustomFormControl(item ? item?.defendants : null, 'Defendant Representing', [Validators.required]),
      // 'defendantCounsellRepresenting': new CustomFormControl(item ? item?.defendantCounsellRepresenting : null, 'Defendant Representing', [Validators.required]),
      'defendantCounselAttorneyName': new CustomFormControl(item ? item?.name : null, 'Defendant Name', [Validators.required]),
      'streetAddress': new FormControl(item ? item?.streetAddress : null),
      'city': new FormControl(item ? item?.city : null),
      'state': new FormControl(item ? item?.state : null),
      'zip': new FormControl(item ? item?.zip : null),
      'phone': new FormControl(item ? item?.phone : null),
      'extn': new FormControl(item ? item?.extn : null),
      'fax': new FormControl(item ? item?.fax : null),
      'email': new FormControl(item ? item?.email : null, Validators.email),
      'isNew': new FormControl(item ? item.isNew : true),
      'keys': new FormControl(keys)
    });
  }
  /**
  * Highlights a control for validation.
  */
  isError(controlId: any, control?:any) {
    let formControl = this.formGroup.get(controlId);
    if(!formControl)
      formControl = control.get(controlId);
    return formControl ? (formControl.invalid && (formControl.dirty || formControl.touched)) : false;
  }

  delete() {
    if(this.itemToDelete >= 0) {
      switch(this.deleteType) {
        case 'defendant':
          this.defendantCounseals.removeAt(this.itemToDelete);
          break;
        case 'plaintiffCounseal':
          this.plaintiffCounseals.removeAt(this.itemToDelete);
      }
      this.itemToDelete = null;
      this.showDeleteModal = false;
      this.deleteType = '';
    }
    
  }


  initializeFormData() {
    if (this.formData?.defendantCounseals) {
      this.defendantCounseals.clear();
      _.forEach(this.formData?.defendantCounseals, defendant => {
        this.defendantCounseals.push(this.createdefendantCounsealFormGroup(defendant));
      })
    }

    if (this.formData?.plaintiffCounseals) {
      this.plaintiffCounseals.clear();
      _.forEach(this.formData?.plaintiffCounseals, plaintiffCounseal => {
            this.plaintiffCounseals.push(this.createplaintiffCounsealFormGroup(plaintiffCounseal));
          })
}

    this.formGroup.patchValue({
      plaintiffCounseals: this.formData?.plaintiffCounseals,
      defendantCounseals: this.formData?.defendantCounseals,
      chooseCounsell: true,
      initialPleading: this.formData?.initialPleading,
      orderInfoAttachmentFile: this.formData?.orderInfoAttachmentFile,
      judge: this.formData?.judge,
      court: this.formData?.court,
      courtKeys: this.formData?.courtKeys,
      courtStreetAddress: this.formData?.courtStreetAddress,
      jurisdictionCounty: this.formData?.jurisdictionCounty,
      state: this.formData?.state,
      cityName: this.formData?.cityName,
      zipCode: this.formData?.zipCode,
      caseNumber: this.formData?.caseNumber,
      caseName: this.formData?.caseName
    });
    this.attachments = this.formGroup?.get('orderInfoAttachmentFile')?.value ? this.formGroup.get('orderInfoAttachmentFile')?.value : [];
  }

   
}
